import React, { useState, useContext} from "react";
import { useTranslation } from "react-i18next";
import FileInfo from "./file_info.js";
import DownloadHistory from "./download_history.js";
import {hasDMSAdminRights} from "../../../assets/menus/menu_helper.js";
import UserContext from "../../../components/User_Context.js";
import { useEditPanelContext } from "./edit_panel_context.js";
import StatusTab from "./status_tab.js";
import LinkedFilesTab from "./linked_files_tab.js"; 

function EditPanel() {
  const { t } = useTranslation("labels");
  const [isEditPanelFullscreen, setIsEditPanelFullscreen] = useState(false);
  const { item, userRights, linkedFilesManager, CanIEditLinkedFile = false } = useEditPanelContext();
  const { currentUser } = useContext(UserContext);
  const isFile = item?.type === "file";
  return (
    <>
      <div
        className={`offcanvas offcanvas-end  `}
        style={{
          "--bs-offcanvas-width": isEditPanelFullscreen ? "100vw" : "800px",
          width: isEditPanelFullscreen ? "100vw" : "800px",
          transition: "width 0.3s ease-in-out",
        }}
        tabIndex="-1"
        id="editPanel"
      >
        <div className="offcanvas-header">
          <h3 className="modal-title " id="#gridSystemModal">
            {t("edit", { ns: "labels" })}
          </h3>

          <div className="customeoff d-flex align-items-center">
            <button
              type="button"
              className="btn btn-light me-2"
              style={{
                borderRadius: "6px",
                fontSize: "18px",
                width: "36px",
                height: "36px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
              }}
              aria-label="Toggle Fullscreen"
              onClick={() => setIsEditPanelFullscreen((prev) => !prev)}
            >
              <i
                className="fa-solid fa-expand"
                hidden={isEditPanelFullscreen}
              ></i>
              <i
                className="fa-solid fa-compress"
                hidden={!isEditPanelFullscreen}
              ></i>
            </button>
            <button
              type="button"
              className="btn-close"
              style={{
                borderRadius: "6px",
                fontSize: "18px",
                width: "36px",
                height: "36px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
              }}
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div className="offcanvas-body d-flex flex-column p-0 ">
          {/* {hasDMSAdminRights(currentUser() && isFile)   */}
          {hasDMSAdminRights(currentUser() )  && isFile
          ? (
            <>
            <ul className="nav nav-tabs " id="myTab" role="tablist">
            <li className="nav-item ms-2  " role="presentation" >
              <button
                className="nav-link active"
                id="file-info-tab"
                data-bs-toggle="tab"
                data-bs-target="#fileInfo"
                type="button"
                role="tab"
                aria-controls="fileInfo"
                aria-selected="true"
              >
                {t("fileInfo")}
              </button>
            </li>
            {(userRights === "approval" || userRights === "validator") && (
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="download-history-tab"
                data-bs-toggle="tab"
                data-bs-target="#downloadHistory"
                type="button"
                role="tab"
                aria-controls="downloadHistory"
                aria-selected="false"
              >
                {t("downloadHistory")}
              </button>
            </li>)}
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="status-tab"
                data-bs-toggle="tab"
                data-bs-target="#status"
                type="button"
                role="tab"
                aria-controls="status"
                aria-selected="false"
              >
                {t("status")}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="linked-files-tab"
                data-bs-toggle="tab"
                data-bs-target="#linkedFiles"
                type="button"
                role="tab"
                aria-controls="linkedFiles"
                aria-selected="false"
              >
                {t("linkedFiles")}
              </button>
            </li>
          </ul>
          <div className="tab-content  h-100 overflow-y-auto scrollbar-custom flex-grow-1 overflow-hidden" id="myTabContent">
            <div
              className="tab-pane fade show active h-100 "
              id="fileInfo"
              role="tabpanel"
              aria-labelledby="file-info-tab"
            >
              
              <FileInfo />
            </div>
            
             {(userRights === "approval" || userRights === "validator") && (<div
                    className="tab-pane fade h-100 overflow-hidden"
                    id="downloadHistory"
                      role="tabpanel"
                      aria-labelledby="download-history-tab"
                    >
                      <DownloadHistory />
                    </div>
                  ) }
      
       
            <div
              className="tab-pane fade h-100 "
              id="status"
              role="tabpanel"
              aria-labelledby="status-tab"
            >
              <StatusTab />
            </div>
            <div
              className="tab-pane fade h-100 "
              id="linkedFiles"
              role="tabpanel"
              aria-labelledby="linked-files-tab"
            >
              <LinkedFilesTab linkedFilesManager={linkedFilesManager} item={item} CanIEditLinkedFile={CanIEditLinkedFile} />
            </div>
          </div>
            </>
          ):    <FileInfo />}
          
          
        </div>
      </div>
    </>
  );
}

export default EditPanel;
